export const pathes = {
  BASE_PATH: '/marketplace/:instituteId/:storeTypeName',
  DEFAULT: '/',
  SELECT_ADDRESS: '/select-address',
  ADD_ADDRESS: '/add-address',
  EDIT_ADDRESS: '/edit-address/:addressId',
  SELECT_STORE: '/select-store',
  HOME: '/home',
  SEARCH: '/search',
  PRODUCT_DETAILS: '/product-details/:productId',
  ADD_PRODUCTS: '/add-products/:categoryId',
  CART_LIST: '/cart-list',
  STORE_CART: '/store-cart',
  CART_DETAILS: '/cart-details/:cartId',
  PAYMENT: '/cart-details/:cartId/payment',
  ACCOUNT: '/account',
  ORDERS: '/orders',
  ORDER_DETAILS: '/order-details/:orderId',
  SELECT_DATE: '/select-date',
  SUCCESS_ORDER: '/success-order/:orderId',
  SELECT_REORDER_ADDRESS: '/select-reorder-address',
  SCAN_QR_CODE: '/scan-qr-code',
  PAYMENT_CODE: '/payment-code',
  REPORT_ORDER: '/report-order/:orderId',
  STATIONS: '/stations',
}
